// src/components/UI/ReferralBonusModal.js
import React from 'react';
import { FaTimes, FaGift, FaCoins, FaCrown } from 'react-icons/fa';
import styles from './ReferralBonusModal.module.css';

/**
 * Modal component to display referral bonus notification
 * Shows when a user successfully claims their referral bonus
 */
const ReferralBonusModal = ({ show, onClose, creditsAdded = 10, tokensAdded = 5 }) => {
    if (!show) return null;

    return (
        <div className={styles.overlay}>
            <div className={styles.popup}>
                {/* Header with Close Button */}
                <div className={styles.header}>
                    <button className={styles.closeButton} onClick={onClose} aria-label="Close">
                        <FaTimes />
                    </button>
                </div>

                {/* Content */}
                <div className={styles.content}>
                    {/* Gift Icon */}
                    <div className={styles.iconWrapper}>
                        <FaGift className={styles.giftIcon} />
                    </div>

                    {/* Title */}
                    <h2 className={styles.title}>Welcome Bonus!</h2>

                    {/* Subtitle */}
                    <p className={styles.subtitle}>
                        Thank you for joining EcomBuddha through a referral!
                    </p>

                    {/* Bonus Cards */}
                    <div className={styles.bonusSection}>
                        <div className={styles.bonusCard}>
                            <div className={styles.bonusIcon}>
                                <FaCoins className={styles.coinsIcon} />
                            </div>
                            <div className={styles.bonusAmount}>+{creditsAdded}</div>
                            <div className={styles.bonusLabel}>Credits</div>
                        </div>

                        <div className={styles.bonusCard}>
                            <div className={styles.bonusIcon}>
                                <FaCrown className={styles.crownIcon} />
                            </div>
                            <div className={styles.bonusAmount}>+{tokensAdded}</div>
                            <div className={styles.bonusLabel}>Tokens</div>
                        </div>
                    </div>

                    {/* Message */}
                    <p className={styles.message}>
                        You've received {creditsAdded} credits and {tokensAdded} tokens as your welcome bonus! Start creating amazing product listings now!
                    </p>
                </div>

                {/* Action Button */}
                <div className={styles.navigationActions}>
                    <button className={`${styles.btn} ${styles.btnPrimary}`} onClick={onClose}>
                        Get Started
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ReferralBonusModal;
